/**
 * Format a numeric PHP price like ₱12,500,000.
 * Returns "—" for null/undefined/0-with-hide.
 */
export function formatPhp(amount, { hideZero = false } = {}) {
  if (amount == null) return "—";
  const n = Number(amount);
  if (Number.isNaN(n)) return "—";
  if (hideZero && n === 0) return "—";
  return "₱" + n.toLocaleString("en-PH", { maximumFractionDigits: 0 });
}

/** Compact "12.5M" style for tight card layouts. */
export function formatPhpCompact(amount) {
  const n = Number(amount || 0);
  if (!n) return "—";
  if (n >= 1_000_000) return `₱${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`;
  if (n >= 1_000) return `₱${(n / 1_000).toFixed(0)}K`;
  return `₱${n}`;
}

/** Short relative date for cards. */
export function formatDateShort(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-PH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

/**
 * Days on Market — whole days since the ISO timestamp. Clamped ≥ 0.
 * Returns an integer.
 */
export function daysOnMarket(iso) {
  if (!iso) return 0;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 0;
  const diffMs = Date.now() - d.getTime();
  if (diffMs <= 0) return 0;
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}

/** Human-friendly DOM label, e.g. "Today", "1 day", "42 days". */
export function daysOnMarketLabel(iso) {
  const n = daysOnMarket(iso);
  if (n <= 0) return "Today";
  if (n === 1) return "1 day";
  return `${n} days`;
}
